var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0595 6.00008L7.99951 9.05341L4.93951 6.00008L3.99951 6.94008L7.99951 10.9401L11.9995 6.94008L11.0595 6.00008Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "97131/static/media/Collapse.d274b6783c3ca4d5e8a3d7639add8fb8.svg";
export { ForwardRef as ReactComponent };